export const sliderItems = [
    {
        id: 1,
        bg: "#95eef5",
        img: "https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8ZmFzaGlvbnxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60",
        title: "SUMMER SALE",
        desc: "Don't compromise on style. Get FLAT 25% off on new arrivals!",
    },
    {
        id: 2,
        bg: "#c1f779",
        img: "https://images.unsplash.com/photo-1509631179647-0177331693ae?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8OXx8ZmFzaGlvbnxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60",
        title: "Autumn Collection",
        desc: "Don't compromise on style. Get FLAT 25% off on new arrivals!",
    },
    {
        id: 3,
        bg: "#faaaf6",
        img: "https://images.unsplash.com/photo-1487222477894-8943e31ef7b2?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MjN8fGZhc2hpb258ZW58MHx8MHx8&auto=format&fit=crop&w=500&q=60",
        title: "WINTER SALE",
        desc: "Don't compromise on style. Get FLAT 25% off on new arrivals!",
    },
];

export const categories = [
    {
        id: 1,
        img: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MzR8fGZhc2hpb258ZW58MHx8MHx8&auto=format&fit=crop&w=500&q=60",
        title: "Shirt",
    },
    {
        id: 2,
        img: "https://images.unsplash.com/photo-1552374196-1ab2a1c593e8?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NTl8fGZhc2hpb258ZW58MHx8MHx8&auto=format&fit=crop&w=500&q=60",
        title: "Jeans",
    },
    {
        id: 3,
        img: "https://images.unsplash.com/photo-1485462537746-965f33f7f6a7?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mjl8fGZhc2hpb258ZW58MHx8MHx8&auto=format&fit=crop&w=500&q=60",
        title: "Jacket",
    },
];

export const popularProducts = [
    {
        id:1,
        img:"https://images.unsplash.com/photo-1434389677669-e08b4cac3105?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8N3x8Y2xvdGhlc3xlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60",
      },
      {
        id:2,
        img:"https://images.unsplash.com/photo-1537274942065-eda9d00a6293?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTF8fGNsb3RoZXN8ZW58MHx8MHx8&auto=format&fit=crop&w=500&q=60",
      },
      {
        id:3,
        img:"https://images.unsplash.com/photo-1523381294911-8d3cead13475?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTR8fGNsb3RoZXN8ZW58MHx8MHx8&auto=format&fit=crop&w=500&q=60",
      },
      {
        id:4,
        img:"https://images.unsplash.com/photo-1591047139829-d91aecb6caea?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTZ8fGNsb3RoZXN8ZW58MHx8MHx8&auto=format&fit=crop&w=500&q=60",
      },
      {
        id:5,
        img:"https://media.istockphoto.com/photos/funny-west-highland-white-terrier-dog-decorated-with-photo-props-sits-picture-id1292884801?b=1&k=20&m=1292884801&s=170667a&w=0&h=L5QgEFpFN1be2Qx8Q9PUWolafU_ecaqYiNwga6eoqxs=",
      },
      {
        id:6,
        img:"https://media.istockphoto.com/photos/rack-with-stylish-womens-summer-clothes-concept-for-shopping-store-picture-id1321255356?b=1&k=20&m=1321255356&s=170667a&w=0&h=BqOL-oL0mfptcRJnfLn0igO3SU247P3HgTGralsRhaU=",
      },
      {
        id:7,
        img:"https://media.istockphoto.com/photos/stacked-and-ready-to-be-packed-picture-id1286024201?b=1&k=20&m=1286024201&s=170667a&w=0&h=VrN3KFXrlnXDvSME2hFLb7EP9DGoUNXHCU_NNZ68Bwo=",
      },
      {
        id:8,
        img:"https://media.istockphoto.com/photos/close-up-of-colorful-tshirts-on-hangers-apparel-background-picture-id1170635789?b=1&k=20&m=1170635789&s=170667a&w=0&h=5CZtqZRGBRkQtZw3YIRotRDu4OROZPSkXeyzaMs-xYE=",
      },
]